import { Link } from "react-router-dom";
import { ArrowLeft, Wrench } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const LOGO_URL = "/gv_logo.png";

const LoginInProgress = () => {
  return (
    <div className="min-h-screen bg-[#2c041c] flex flex-col items-center justify-center px-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="text-center max-w-md">
        <img src={LOGO_URL} alt="Guli Ventures" className="w-16 h-16 mx-auto mb-6 object-contain" />
        <div className="w-16 h-16 mx-auto mb-6 bg-[#d7be69]/10 rounded-full flex items-center justify-center">
          <Wrench size={32} weight="duotone" className="text-[#d7be69]" />
        </div>
        <h1 className="text-3xl font-semibold text-[#d7be69] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }} data-testid="login-in-progress-heading">
          Login Page In Progress
        </h1>
        <p className="text-[#C4B09A] text-base leading-relaxed mb-8">
          We are currently integrating our client login portal. This feature will be available soon. Thank you for your patience.
        </p>
        <Link to="/" data-testid="back-to-home-btn"
          className="inline-flex items-center gap-2 bg-[#d7be69] text-[#260F1A] px-6 py-3 font-semibold hover:bg-[#E0C88B] transition-colors rounded">
          <ArrowLeft size={18} weight="bold" /> Back to Home
        </Link>
      </motion.div>

      <p className="text-[10px] text-[#6B5A52] mt-16 text-center">
        AMFI Registered Mutual Fund Distributor | ARN - 358908 | Guli Ventures, Mysuru
      </p>
    </div>
  );
};

export default LoginInProgress;
